import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  FloatButton,
  Tooltip,
  Card,
  Typography,
  Tabs,
  InputNumber,
  Upload,
  Collapse,
  Avatar,
  ColorPicker,
  Checkbox,
  DatePicker,
  Calendar,
  Tag,
  message
} from "antd";
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  PlusCircleFilled,
  CheckCircleOutlined,
  StopFilled,
  CloseCircleOutlined,
  RocketFilled,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  CaretRightOutlined,
  RightCircleFilled,
  CommentOutlined,
  CustomerServiceOutlined,
  SwapRightOutlined,
  InfoCircleFilled,
  EditFilled,
  DownloadOutlined
} from '@ant-design/icons';
import { Form } from "@ant-design/compatible";
import { resolveSelectedSite } from 'src/utils/selectedSite';
import { withIsMobile } from 'src/utils/responsive';
import Notify from "src/components/meta/Notification";
import Highlighter from "react-highlight-words";
import Resizer from 'react-image-file-resizer';
import payfastImg from 'src/static/Payfast-io-logo.png';
import CODImg from 'src/static/cod-icon.png';
import EFTImg from 'src/static/eft-icon.png';
import ShippingImg from 'src/static/shipping-icon.png';
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isLeapYear from 'dayjs/plugin/isLeapYear';
import XLSX from 'sheetjs-style';
import { saveAs } from 'file-saver';

dayjs.extend(isLeapYear);
dayjs.extend(dayOfYear);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);



const { Title } = Typography;
const { TextArea } = Input;
const { Column } = Table;
const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const { Option } = Select;

const LeaveRangePickerMobileStyles = createGlobalStyle`
  @media (max-width: 991px) {
    .mobile-leave-range-picker {
      right: 0.5em !important;
      left: 0.5em !important;
      width: auto !important;
      max-width: calc(100vw - 1em) !important;
    }
    .mobile-leave-range-picker .ant-picker-panel-container {
      width: 100%;
      max-width: 100%;
      max-height: calc(100vh - 7em);
      overflow-x: hidden;
      overflow-y: auto;
      border-radius: 10px;
    }
    .mobile-leave-range-picker .ant-picker-panels {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .mobile-leave-range-picker .ant-picker-panel,
    .mobile-leave-range-picker .ant-picker-date-panel {
      width: 100%;
      min-width: 0;
    }
    .mobile-leave-range-picker .ant-picker-body {
      padding: 0.6em;
    }
    .mobile-leave-range-picker .ant-picker-content {
      width: 100%;
      table-layout: fixed;
    }
    .mobile-leave-range-picker .ant-picker-header-view {
      min-width: 0;
      font-size: 13px;
    }
  }
`;

const ResponsiveFormWrap = styled.span`
  @media (max-width: 991px) {
    display: block;
    width: 100%;
    min-width: 0;

    .ant-col {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      margin-top: 0 !important;
    }
    .ant-row {
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 1em !important;
      padding-right: 1em !important;
    }
    .ant-form-item {
      margin-bottom: 1em;
    }
    .ant-input,
    .ant-input-number,
    .ant-picker,
    .ant-select {
      width: 100% !important;
      max-width: 100% !important;
    }
    .ant-input,
    .ant-input-number,
    .ant-picker,
    .ant-select-selector {
      min-height: 44px !important;
      border-radius: 8px !important;
    }
    .ant-input,
    .ant-picker-input > input,
    .ant-input-number-input,
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      font-size: 16px !important;
    }
    .ant-form-item-label {
      padding-bottom: 0.3em;
    }
    .ant-form-item-label > label {
      height: auto;
      white-space: normal;
      line-height: 1.3;
    }
    .ant-collapse {
      overflow: hidden;
      border: 1px solid #e4ece6 !important;
      border-radius: 10px;
      background: #fff;
    }
    .ant-collapse > .ant-collapse-item > .ant-collapse-header {
      align-items: center;
      min-height: 48px;
      padding: 0.8em 1em !important;
      background: #f4f8f5;
      color: #35553d;
      font-weight: 700;
    }
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0.8em 0 0 !important;
    }
    .leave-entry-controls .ant-btn {
      width: 100%;
      min-height: 44px;
      margin-top: 0 !important;
      border-radius: 8px;
    }
    .leave-entry-controls .ant-picker-range {
      display: flex;
      min-width: 0;
      padding-right: 0.6em;
      padding-left: 0.6em;
    }
    .leave-entry-controls .ant-picker-range .ant-picker-input {
      min-width: 0;
    }
    .leave-entry-controls .ant-picker-range .ant-picker-input > input {
      min-width: 0;
      font-size: 14px !important;
      text-align: center;
    }
    .leave-entry-controls .ant-picker-range-separator {
      flex: 0 0 auto;
      padding: 0 0.25em;
    }
  }
`;
const StyledTable = styled(Table)`
  @media (max-width: 991px) {
    .ant-table-content,
    .ant-table-body {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-x pan-y;
      scrollbar-width: thin;
      scrollbar-color: #80ce90 #eef2ef;
    }
    .ant-table-content::-webkit-scrollbar,
    .ant-table-body::-webkit-scrollbar {
      height: 8px;
    }
    .ant-table-content::-webkit-scrollbar-track,
    .ant-table-body::-webkit-scrollbar-track {
      background: #eef2ef;
      border-radius: 999px;
    }
    .ant-table-content::-webkit-scrollbar-thumb,
    .ant-table-body::-webkit-scrollbar-thumb {
      background: #80ce90;
      border-radius: 999px;
    }
    .ant-table table {
      min-width: 40em;
    }
    .ant-table-thead > tr > th {
      white-space: nowrap;
      padding: 10px 12px;
      background: #fafafa !important;
      color: #262626 !important;
      font-size: 12px;
      font-weight: 700;
    }
    .ant-table-cell-fix-right {
      background: #fff;
      z-index: 4;
      box-shadow: -5px 0 10px rgba(0, 0, 0, 0.06);
    }
    .ant-table-thead .ant-table-cell-fix-right {
      background: #fafafa !important;
      z-index: 6;
    }
    .ant-table-container {
      overflow: hidden;
      border: 1px solid #e3ebe5;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 4px 14px rgba(31, 61, 38, 0.06);
    }
    .ant-table-tbody > tr > td {
      padding: 10px 12px;
      font-size: 13px;
      line-height: 1.35;
    }
    .ant-table-tbody > tr:nth-child(even) > td {
      background: #fbfcfb;
    }
    .ant-table-thead > tr > th:first-child,
    .ant-table-tbody > tr > td:first-child {
      position: sticky !important;
      left: 0;
      z-index: 4;
      background: #fff !important;
      box-shadow: 5px 0 10px rgba(0, 0, 0, 0.05);
    }
    .ant-table-thead > tr > th:first-child {
      background: #fafafa !important;
      z-index: 6;
    }
    .ant-table-tbody > tr:nth-child(even) > td:first-child {
      background: #fbfcfb !important;
    }
    .ant-table-tbody .ant-table-cell-fix-right .anticon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 36px;
      min-height: 36px;
    }
    .ant-pagination {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      row-gap: 0.5em;
    }
  }
`;
const Cards = styled(Card)`

  :where(.css-dev-only-do-not-override-133wgew).ant-card .ant-card-body{
    padding-left:0px !important;
    padding-bottom: 3em !important;
  }

  @media (max-width: 991px) {
    width: 100%;
    min-width: 0;
    margin-bottom: 1em;

    > .ant-card-head {
      min-height: auto;
      padding: 0.9em 1em;
      border-bottom: 1px solid #edf1ee;
    }
    .ant-card-head-wrapper {
      flex-wrap: wrap;
      gap: 0.5em;
    }
    .ant-card-extra {
      width: 100%;
      margin-left: 0;
    }
    > .ant-card-body {
      padding: 1em !important;
      padding-bottom: 6em !important;
    }
  }
`;
const MobileEditActions = styled.div`
  display: none;

  @media (max-width: 991px) {
    position: fixed;
    right: 1em;
    bottom: 0.5em;
    bottom: calc(0.5em + env(safe-area-inset-bottom));
    left: 1em;
    z-index: 50;
    display: flex;
    gap: 0.65em;
    padding: 0.65em;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.8em;
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
    backdrop-filter: blur(8px);

    .ant-btn {
      flex: 1 1 0;
      height: 44px;
      border-radius: 0.65em;
      font-weight: 700;
    }
  }
`;
const LeaveToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
  flex-direction: row-reverse;

  @media (max-width: 991px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.55em;

    .leave-export,
    .leave-add {
      width: 100%;
      min-width: 0;
      height: 44px;
      margin-top: 0 !important;
    }
    .leave-year,
    .leave-site {
      grid-column: 1 / -1;
      width: 100% !important;
    }
  }
`;
const LeaveViewTabs = styled(Tabs)`
  @media (max-width: 991px) {
    .ant-tabs-nav {
      margin: 0.9em 0;
      padding: 0.35em;
      border: 1px solid #dfe9e2;
      border-radius: 10px;
      background: #fff;
    }
    .ant-tabs-nav-list {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      width: 100%;
    }
    .ant-tabs-tab {
      justify-content: center;
      min-height: 40px;
      margin: 0 !important;
      padding: 0.55em !important;
      border-radius: 7px;
      background: #f2f6f3;
      font-weight: 800;
    }
    .ant-tabs-tab-active {
      background: #def1e2;
    }
    .ant-tabs-ink-bar {
      display: none;
    }
  }
`;
const MobileTableHelp = styled.div`
  display: none;

  @media (max-width: 991px) {
    display: flex;
    align-items: center;
    gap: 0.55em;
    margin-bottom: 0.7em;
    padding: 0.65em 0.8em;
    border: 1px solid rgba(128, 206, 144, 0.45);
    border-radius: 10px;
    background: #f3faf5;
    color: #42624a;
    font-size: 12px;

    strong {
      flex: 0 0 auto;
      padding: 0.25em 0.45em;
      border-radius: 5px;
      background: #dff2e3;
      color: #2f7e43;
      font-size: 10px;
      letter-spacing: 0.04em;
    }
  }
`;
const CalendarEditorWrap = styled.div`
  @media (max-width: 991px) {
    overflow: hidden;
    border: 1px solid #e3ebe5;
    border-radius: 10px;
    background: #fff;

    .ant-picker-calendar-header {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0.5em;
      padding: 0.75em;
    }
    .ant-picker-calendar-header .ant-picker-calendar-year-select,
    .ant-picker-calendar-header .ant-picker-calendar-month-select {
      width: 100% !important;
    }
    .ant-picker-calendar-header .ant-picker-calendar-mode-switch {
      grid-column: 1 / -1;
      margin-left: 0;
    }
    .ant-picker-content th {
      padding: 0.45em 0;
      font-size: 10px;
      text-align: center;
    }
    .ant-picker-calendar-date {
      min-height: 74px !important;
      margin: 0 !important;
      padding: 3px 2px !important;
    }
    .ant-picker-calendar-date-value {
      font-size: 11px;
    }
    .ant-picker-calendar-date-content {
      height: 48px !important;
      overflow-y: auto;
    }
    .ant-tag {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-width: 0;
      margin: 1px 0;
      padding: 0 2px;
      overflow: hidden;
      font-size: 9px;
      line-height: 16px;
      text-overflow: ellipsis;
    }
    .ant-tag-close-icon {
      margin-left: 2px;
    }
  }
`;
const CalendarLegend = styled.div`
  display: none;

  @media (max-width: 991px) {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35em;
    margin-bottom: 0.65em;

    .ant-tag {
      margin: 0;
      font-size: 10px;
    }
  }
`;
const MonthlyCalendarsWrap = styled.div`
  .calendar-month-card {
    margin-bottom: 2em;
  }

  @media (max-width: 991px) {
    .calendar-month-select {
      width: 100%;
      margin-bottom: 0.8em;
    }
    .calendar-month-card {
      margin-bottom: 1em;
      padding: 0.75em;
      border: 1px solid #e3ebe5;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0 4px 14px rgba(31, 61, 38, 0.06);
    }
    .calendar-month-card h4 {
      margin: 0 0 0.65em;
      font-size: 16px;
    }
    .monthly-calendar-table .ant-table-thead > tr > th {
      padding: 7px 5px;
      background: #fafafa !important;
      color: #262626 !important;
      font-size: 11px;
      text-align: center;
    }
    .monthly-calendar-table .ant-table-tbody > tr > td {
      padding: 5px 4px;
      text-align: center;
    }
    .monthly-calendar-table .ant-table-cell-fix-left {
      background: #fff;
      text-align: left !important;
      box-shadow: 5px 0 10px rgba(0, 0, 0, 0.05);
    }
    .monthly-calendar-table .ant-tag {
      margin: 0;
      padding: 0 4px;
    }
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: '';
  }
`;
const StyledInputNumber = styled(InputNumber)`
  font-weight: 500 !important;
  color: #525f7f !important;
  font-size: 15px !important;
  cursor: not-allowed;
  .ant-input-number-disabled .ant-input-number-input {
    font-weight: 500 !important;
    color: #525f7f !important;
    font-size: 15px !important;
    cursor: not-allowed;
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;

function callback(key) {
  console.log(key);
}
const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}

function handleChange(value) {
  console.log(`selected ${value}`);
}
class TailoringFormClass extends React.Component {
  state = {
    descriptions: this.props.descriptions,
    mainHomeImage: undefined,
    mainSpecialImage1: undefined,
    isPayfastChecked: this.props.editTailoring
      ? this.props.editTailoring.isPayfast
      : false,
    isCollectionChecked: this.props.editTailoring
      ? this.props.editTailoring.isCollection
      : false,
    isEFTChecked: this.props.editTailoring
      ? this.props.editTailoring.isEFT
      : false,
    isShippingCostChecked: this.props.editTailoring
      ? this.props.editTailoring.isShippingCost
      : false,
    loggedDates: [],

  };
  componentDidMount = () => {
    if (this.props.editTailoring) {
      const { loggedDates } = this.props.editTailoring || {};
      console.log("Loaded Logged Dates for Editing:", loggedDates); // Debugging
      this.setState({
        loggedDates: loggedDates || [],
      });
    }
  };
  handleAddToCalendar = () => {
    const leaveType = this.props.form.getFieldValue("leaveType");
    const leaveDate = this.props.form.getFieldValue("leaveDate");

    if (!leaveType || !leaveDate) {
      Notify("error", "Please select a leave type and date range");
      return;
    }

    const [startDate, endDate] = leaveDate.map((date) => date.format("YYYY-MM-DD"));

    const datesToAdd = [];
    let currentDate = dayjs(startDate);

    while (currentDate.isSameOrBefore(dayjs(endDate))) {
      datesToAdd.push({ date: currentDate.format("YYYY-MM-DD"), type: leaveType });
      currentDate = currentDate.add(1, "day");
    }

    console.log("Generated Dates to Add:", datesToAdd); // Debugging

    this.setState((prevState) => {
      const mergedLoggedDates = [
        ...prevState.loggedDates,
        ...datesToAdd.filter(
          (newEntry) =>
            !prevState.loggedDates.some(
              (existingEntry) =>
                existingEntry.date === newEntry.date &&
                existingEntry.type === newEntry.type
            )
        ),
      ];

      console.log("Updated Logged Dates:", mergedLoggedDates); // Debugging

      return { loggedDates: mergedLoggedDates };
    });
  };


  removeLoggedDate = (date, type) => {
    console.log("Attempting to Remove Entry:", { date, type }); // Debugging

    this.setState((prevState) => {
      const updatedDates = prevState.loggedDates.filter(
        (entry) => !(entry.date === date && entry.type === type) // Remove only matching date and type
      );

      console.log("Updated Logged Dates After Removal:", updatedDates); // Debugging

      return { loggedDates: updatedDates };
    });
  };

  handlemainHomeImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainHomeImage: imageUrl
      });
    });
  };
  handleMainSpecialImage1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainSpecialImage1: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1200, 1200, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };
  selectItem = value => {
    if (value.substr(0, 4) === "Add ") {
      let parsedValue = value.substr(4, value.length);
      this.props.form.setFieldsValue({ description: parsedValue });
      let descriptions = this.state.descriptions;
      descriptions.pop();
      descriptions.push({ value: parsedValue });
      this.setState({ descriptions: descriptions });
    }
  };
  searchItem = (value, b) => {
    let descriptions = this.state.descriptions;
    if (descriptions[descriptions.length - 1].value.substr(0, 4) === "Add ") {
      descriptions.pop();
    }
    if (
      !descriptions.find(
        descriptions => descriptions.value.toLowerCase() === value.toLowerCase()
      ) &&
      value !== ""
    ) {
      descriptions.push({ value: "Add " + value });
    }
    this.setState({ descriptions: descriptions });
  };
  handlePayfastChange = (e) => {
    this.setState({ isPayfastChecked: e.target.checked });
  };

  handleCollectionChange = (e) => {
    this.setState({ isCollectionChecked: e.target.checked });
  };

  handleEFTChange = (e) => {
    this.setState({ isEFTChecked: e.target.checked });
  };

  handleShippingCostChange = (e) => {
    this.setState({ isShippingCostChecked: e.target.checked });
  };

  render() {
    return (
      <ResponsiveFormWrap>
      <Form layout="vertical">

        <Divider orientation="left" orientationmargin={0}>Leave Schedule</Divider>
        <Collapse
          bordered={false}
          defaultActiveKey={['1']}
          expandIcon={({ isActive }) => <RightCircleFilled rotate={isActive ? 90 : 0} />}
          items={[
            {
              key: '1',
              label: 'Manage Off and Leave Liability ',
              children:
                <>
                  <Row gutter={24} style={{ padding: "2em", paddingTop: "1em", paddingBottom: "1em" }}>
                    {/* <Col span={5}>
                      <FormItem
                        // style={{ marginBottom: '1em' }}
                        label="Lodge / Banda"
                      >
                        {this.props.form.getFieldDecorator(
                          'leaveLodge',
                          {
                            rules: [
                              {
                                required: false,
                                message: 'Category required'
                              }
                            ],
                            initialValue: this.props.editTailoring
                              ? this.props.editTailoring.leaveLodge
                              : this.props.siteSelected
                          }
                        )(
                          <Select
                            // disabled
                            size="large"
                            // mode="multiple" 
                            showSearch>
                            <Option key="Admin" value="Admin">
                              Admin
                            </Option>
                            {this.props.sites.map(site => (
                              <Option key={site._id} value={site._id}>
                                {site.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </FormItem>
                    </Col> */}
                    <Col span={6}>
                      <FormItem label={<span>Assign To</span>}>
                        {this.props.form.getFieldDecorator('user', {
                          initialValue: this.props.editTailoring ? this.props.editTailoring.user : "",
                        })(
                          <Select
                            size="large"
                            showSearch
                            placeholder="Select User"
                          >
                            {this.props.users
                              .filter(user =>
                                user.access && user.access.includes(this.props.siteSelected)
                              )
                              .map(user => (
                                <Option key={user._id} value={user.name}>
                                  {user.name}
                                </Option>
                              ))
                            }
                          </Select>
                        )}
                      </FormItem>
                    </Col>
                    <Col span={6} style={{ display: "none" }}>   <FormItem label={<span>Lodge / Banda</span>}>
                      {this.props.form.getFieldDecorator('access', {
                        initialValue: this.props.editTailoring
                          ? this.props.editTailoring.access
                          : this.props.siteSelected
                      })(
                        <Select
                          size="large"
                          // mode="multiple" 
                          showSearch>
                          {/* <Option key="Admin" value="Admin">
                            Admin
                          </Option> */}
                          {this.props.sites.map(site => (
                            <Option key={site._id} value={site._id}>
                              {site.name}
                              {/* {site.name} ({site._id}) */}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </FormItem>
                    </Col>
                  </Row>
                  <Row
                    className="leave-entry-controls"
                    gutter={24}
                    style={{ padding: "2em", paddingTop: "0em" }}
                  >
                    <Col span={4}>
                      <FormItem label="Select Type">
                        {this.props.form.getFieldDecorator('leaveType', {
                          rules: [{ required: false, message: 'Leave type required' }],
                        })(
                          <Select size="large" allowClear>
                            <Option value="Offdays">Offdays</Option>
                            <Option value="Leave Days">Leave Days</Option>
                            <Option value="Sickdays">Sick Days</Option>
                            <Option value="Maternityleave">Maternity Leave</Option>
                            <Option value="Paternityleave">Paternity Leave</Option>
                            <Option value="Compassionateleave">Compassionate Leave</Option>
                          </Select>
                        )}
                      </FormItem>
                    </Col>

                    <Col span={8}>
                      <FormItem label="Start - End">
                        {this.props.form.getFieldDecorator('leaveDate', {
                          rules: [{ required: false, message: 'Date range required' }],
                        })(
                          <RangePicker
                            popupClassName={
                              this.props.isMobile
                                ? 'mobile-leave-range-picker'
                                : undefined
                            }
                            style={{ width: '100%' }}
                            size="large"
                            format="YYYY-MM-DD"
                            disabledDate={(current) => {
                              // Format the current date to match restricted format "MM-DD"
                              const formattedDate = current.format("MM-DD");

                              // Get the restricted days from the selected site
                              const site = this.props.sites.find(site => site._id === this.props.siteSelected);
                              const restrictedDays = site?.restrictedDays || [];

                              // Disable the restricted dates across all years
                              return restrictedDays.includes(formattedDate);
                            }}
                          />
                        )}
                      </FormItem>
                    </Col>

                    <Col span={4}>
                      <Button
                        style={{ marginTop: "1.8em" }}
                        type="primary"
                        icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                        size="large"
                        onClick={this.handleAddToCalendar}
                      >
                        Add to Calendar
                      </Button>
                    </Col>

                    <Col span={24} style={{ marginTop: '1em' }}>
                      <FormItem >
                        <CalendarLegend>
                          <Tag color="red">R Restricted</Tag>
                          <Tag color="blue">O Off</Tag>
                          <Tag color="orange">L Leave</Tag>
                          <Tag color="yellow">S Sick</Tag>
                          <Tag color="magenta">M Maternity</Tag>
                          <Tag color="cyan">P Paternity</Tag>
                          <Tag color="volcano">C Compassionate</Tag>
                        </CalendarLegend>
                        {/* <Calendar
                          value={
                            this.props.selectedMonth
                              ? dayjs(this.props.selectedMonth, "YYYY")
                              : dayjs() // Default to the current month
                          }
                          onPanelChange={(value, mode) => {
                            const selectedMonth = value.format("YYYY");
                            console.log("Navigated to month:", selectedMonth, "Mode:", mode);
                            this.setState({ selectedMonth });
                          }}
                          onSelect={(value) => {
                            console.log("Selected date:", value.format("YYYY-MM-DD"));
                          }}
                          cellRender={(date) => {
                            const formattedDate = date.format("YYYY-MM-DD");

                            // Only show logged dates matching the selected month
                            const entries = this.state.loggedDates.filter(
                              (entry) =>
                                dayjs(entry.date).format("YYYY") ===
                                dayjs(this.props.selectedMonth, "YYYY").format("YYYY") &&
                                entry.date === formattedDate
                            );

                            return entries.map((entry) => (
                              <Tag
                                color={entry.type === "Offdays" ? "blue" : "green"}
                                key={`${entry.date}-${entry.type}`}
                                closable
                                onClose={() => this.removeLoggedDate(formattedDate, entry.type)}
                              >
                                {entry.type}
                              </Tag>
                            ));
                          }}
                        /> */}
                        <CalendarEditorWrap>
                        <Calendar
                          cellRender={(date) => {
                            // Format the current date as "MM-DD" (to match restrictedDays format)
                            const formattedDate = date.format("MM-DD");

                            // Get restricted days from the selected site
                            const site = this.props.sites.find(site => site._id === this.props.siteSelected);
                            const restrictedDays = site?.restrictedDays || [];

                            // Check if the date is restricted
                            const isRestricted = restrictedDays.includes(formattedDate);

                            // Format full date for logged entries (YYYY-MM-DD)
                            const formattedFullDate = date.format("YYYY-MM-DD");
                            const entries = this.state.loggedDates.filter(
                              (entry) => entry.date === formattedFullDate
                            );

                            return (
                              <div>
                                {isRestricted && (
                                  <Tag color="red" key="restricted" title="Restricted">
                                    {this.props.isMobile ? 'R' : 'Restricted'}
                                  </Tag>
                                )}

                                {entries.map(entry => {
                                  // map each type to a tag‐colour
                                  const colorMap = {
                                    Offdays: 'blue',
                                    'Leave Days': 'orange',
                                    Sickdays: 'yellow',
                                    Maternityleave: 'magenta',
                                    Paternityleave: 'cyan',
                                    Compassionateleave: 'volcano',
                                  };

                                  // if you want prettier labels for the camel-cased keys:
                                  const labelMap = {
                                    Maternityleave: 'Maternity Leave',
                                    Paternityleave: 'Paternity Leave',
                                    Compassionateleave: 'Compassionate Leave',
                                    'Leave Days': 'Leave Days',
                                  };

                                  const tagColor = colorMap[entry.type] || 'green';
                                  const label = labelMap[entry.type] || entry.type;
                                  const mobileLabelMap = {
                                    Offdays: 'O',
                                    'Leave Days': 'L',
                                    Sickdays: 'S',
                                    Maternityleave: 'M',
                                    Paternityleave: 'P',
                                    Compassionateleave: 'C',
                                  };

                                  return (
                                    <Tag
                                      color={tagColor}
                                      key={`${entry.date}-${entry.type}`}
                                      closable
                                      title={label}
                                      onClose={() => this.removeLoggedDate(formattedFullDate, entry.type)}
                                    >
                                      {this.props.isMobile
                                        ? mobileLabelMap[entry.type] || label
                                        : label}
                                    </Tag>
                                  );
                                })}
                              </div>
                            );
                          }}
                          disabledDate={(current) => {
                            // Disable restricted days across all years
                            const formattedDate = current.format("MM-DD");
                            const site = this.props.sites.find(site => site._id === this.props.siteSelected);
                            const restrictedDays = site?.restrictedDays || [];

                            return restrictedDays.includes(formattedDate);
                          }}
                        />
                        </CalendarEditorWrap>
                      </FormItem>
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col span={10} style={{ padding: "2em", paddingTop: "1em" }}>
                      <h1 style={{
                        marginBottom: '1em',
                        fontSize: '15px',
                        fontWeight: 400,

                        // fontFamily: "Nunito",
                      }}>Home Page Image</h1>
                      <Upload
                        name="mainHomeImage"
                        className="avatar-uploader"
                        listType="picture-card"
                        showUploadList={false}
                        beforeUpload={this.beforeUpload}
                        customRequest={this.handleImageUpload}
                        onChange={this.handlemainHomeImage}
                        loading={this.state.loading}
                        accept="image/*"
                      >
                        {
                          this.state.mainHomeImage ? (
                            <img
                              style={{
                                width: '100%',
                                height: "20em",
                                objectFit: "contain"
                              }}
                              alt="example"
                              src={
                                this.state.mainHomeImage.search('data') > -1
                                  ? this.state.mainHomeImage
                                  : process.env.REACT_APP_GLOBAL_SERVER +
                                  'sproutmanagement/api/images/' +
                                  this.state.mainHomeImage
                              }
                            />
                          ) : (
                            <div
                              style={{
                                marginTop: 8,
                              }}
                            >
                              Upload
                            </div>
                          )
                        }
                      </Upload>
                    </Col>
                  </Row> */}
                </>
            },
          ]}
        />



      </Form >
      </ResponsiveFormWrap>
    );
  }
}
const TailoringForm = Form.create()(TailoringFormClass);

const MonthlyCalendarGrid = ({ data, year, isMobile }) => {
  const months = Array.from({ length: 12 }, (_, monthIndex) =>
    `${year}-${String(monthIndex + 1).padStart(2, '0')}`
  );
  const defaultMonthIndex =
    Number(year) === dayjs().year() ? dayjs().month() : 0;
  const [activeMonthIndex, setActiveMonthIndex] = React.useState(
    defaultMonthIndex
  );

  React.useEffect(() => {
    setActiveMonthIndex(Number(year) === dayjs().year() ? dayjs().month() : 0);
  }, [year]);

  const visibleMonths = isMobile ? [months[activeMonthIndex]] : months;

  return (
    <MonthlyCalendarsWrap>
      {isMobile && (
        <Select
          className="calendar-month-select"
          size="large"
          value={activeMonthIndex}
          onChange={setActiveMonthIndex}
          options={months.map((month, index) => ({
            value: index,
            label: dayjs(`${month}-01`).format('MMMM YYYY')
          }))}
        />
      )}
      {visibleMonths.map((month, index) => (
        <div key={month} className="calendar-month-card">
          <Typography.Title level={4}>{dayjs(month).format("MMMM YYYY")}</Typography.Title>
          <CalendarGrid data={data} month={month} isMobile={isMobile} />
        </div>
      ))}
    </MonthlyCalendarsWrap>
  );
};

// const MonthlyCalendarGrid = ({ data, year, selectedMonths = [] }) => {
//   const months = selectedMonths.length > 0
//     ? selectedMonths
//     : Array.from({ length: 12 }, (_, monthIndex) =>
//       dayjs(`${year}-${monthIndex + 1}`, "YYYY-M").format("YYYY-MM")
//     );

//   return (
//     <div>
//       {months.map((month, index) => (
//         <div key={index} style={{ marginBottom: "2em" }}>
//           <Typography.Title level={4}>
//             {dayjs(month).format("MMMM YYYY")}
//           </Typography.Title>
//           <CalendarGrid data={data} month={month} />
//         </div>
//       ))}
//     </div>
//   );
// };

const CalendarGrid = ({ data, month, isMobile }) => {
  const monthStart = dayjs(`${month}-01`);
  const daysInMonth = monthStart.daysInMonth();

  const columns = [
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      fixed: "left",
      width: isMobile ? 110 : 150,
    },
    ...Array.from({ length: daysInMonth }, (_, i) => {
      const date = monthStart.date(i + 1);
      const isSunday = date.day() === 0;

      return {
        title: (
          <Typography.Text style={{ color: isSunday ? "red" : "inherit" }}>
            {i + 1}
          </Typography.Text>
        ),
        dataIndex: `day${i + 1}`,
        key: `day${i + 1}`,
        width: isMobile ? 36 : 40,
        render: (status) => {
          // Sunday override:
          if (isSunday) {
            return <Tag color="red">S</Tag>;
          }

          // Map each status to a tag color + label
          const tagMap = {
            Offdays: { color: "blue", label: "O" },
            Sickdays: { color: "yellow", label: "S" },
            "Leave Days": { color: "green", label: "L" },
            Maternityleave: { color: "magenta", label: "M" },
            Paternityleave: { color: "cyan", label: "P" },
            Compassionateleave: { color: "volcano", label: "C" },
          };

          const tag = tagMap[status];
          return tag
            ? <Tag color={tag.color}>{tag.label}</Tag>
            : null;
        },
      };
    }),
  ];

  // Transform data to match table columns
  const transformedData = data.map((user) => {
    const userRow = { user: user.user };

    for (let i = 1; i <= daysInMonth; i++) {
      const currentDate = dayjs(month).date(i).format("YYYY-MM-DD");
      const loggedDate = user.loggedDates.find((log) => log.date === currentDate);

      userRow[`day${i}`] = loggedDate ? loggedDate.type : null;
    }

    return userRow;
  });

  return (
    <Table
      className="monthly-calendar-table"
      columns={columns}
      dataSource={transformedData}
      bordered
      size={isMobile ? "small" : "middle"}
      scroll={{
        x: daysInMonth * (isMobile ? 44 : 60) + (isMobile ? 110 : 150),
        y: isMobile ? 420 : 500,
      }}
      pagination={false}
      rowKey="user"
    />
  );
};




class Tailoring extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      closed: false,
      rejectReason: "",
      siteSelected: resolveSelectedSite(
        this.props.selectedSite,
        this.props.sites
      ),
      editTailoring: undefined,
      size: "large",
      flag: false,
      currentTab: "All",
      selectedYear: dayjs().format('YYYY'),
      filteredData: [], // Holds the filtered data
      selectedMonths: [dayjs().format("YYYY-MM")],
    };
  }

  componentWillMount = () => {
    this.setState({ loading: true }, this.filterData);

    Promise.all([
      // this.fetchAllStock(),
      this.fetchAllTailoring(),
      this.fetchAllSites(),
      this.fetchAllUsers()
    ])
      .then(() => {
        // On a cold start the constructor ran before sites existed, so
        // siteSelected was null and the first fetch was unscoped. Pick the
        // first site now and redo the fetch so new records save against a real
        // site instead of a null access.
        const siteSelected =
          this.state.siteSelected ||
          (this.props.sites[0] ? this.props.sites[0]._id : null);
        const needsRefetch = !this.state.siteSelected && siteSelected;

        this.setState({ loading: false, siteSelected }, () => {
          if (needsRefetch) {
            this.fetchAllTailoring().then(() => this.filterData());
          } else {
            this.filterData();
          }
        });


        window.addEventListener("resize", this.resizeEvent);

        if (window.cordova) {
          document.addEventListener("backbutton", this.handleBack);
        }
      })
      .catch(error => {
        console.error("Error during componentDidMount:", error);
        this.setState({ loading: false });
        Notify("error", "Error", error.message || "An error occurred");
      });
  };



  // fetchAllStock = () => {
  //   return this.props.findAllStock().catch(error => {
  //     throw new Error(`Error fetching stock: ${error}`);
  //   });
  // };

  fetchAllTailoring = () => {
    const { selectedYear, siteSelected, selectedMonths } = this.state;

    return this.props
      .findAllTailoring(siteSelected, selectedYear, selectedMonths)
      .catch((error) => {
        throw new Error(`Error fetching tailoring: ${error}`);
      });
  };
  fetchAllSites = () => {
    return this.props.findAllSites().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };

  fetchAllUsers = () => {
    return this.props.findAllUsers().catch(error => {
      throw new Error(`Error fetching users: ${error}`);
    });
  };

  handleBack = () => {
    if (this.state.addTailoringVisible) {
      this.setState({ addTailoringVisible: false });
    } else {
      this.props.history.goBack();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener("backbutton", this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  tailoringForm;
  onAddTailoring = e => {
    this.setState({ addTailoringVisible: true, editTailoring: undefined });
  };

  handleAddTailoring = (e) => {
    e.preventDefault();
    this.tailoringForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const updatedLoggedDates = this.tailoringForm.state?.loggedDates || [];
        const currentLoggedDates = this.tailoringForm.state.loggedDates || [];

        // Merge and remove duplicates
        const mergedLoggedDates = [
          ...updatedLoggedDates,
          ...currentLoggedDates.filter(
            (newEntry) =>
              !updatedLoggedDates.some(
                (existingEntry) =>
                  existingEntry.date === newEntry.date &&
                  existingEntry.type === newEntry.type
              )
          ),
        ];

        console.log("Final Merged Logged Dates:", mergedLoggedDates); // Debugging

        values.loggedDates = mergedLoggedDates; // Save updated dates
        values.mainHomeImage = this.tailoringForm.state.mainHomeImage;
        values.mainSpecialImage1 = this.tailoringForm.state.mainSpecialImage1;

        if (this.state.editTailoring) {
          values._id = this.state.editTailoring._id;
        } else {
          // A user has one leave record per site. Without this, "Add Schedule"
          // on someone who already has a record creates a second document and
          // the days end up split across two rows.
          const existing = this.props.tailoring.find(
            item =>
              item.user === values.user &&
              String(item.access || "") === String(values.access || "")
          );

          if (existing) {
            values._id = existing._id;
            const previous = existing.loggedDates || [];
            values.loggedDates = [
              ...previous,
              ...mergedLoggedDates.filter(
                entry =>
                  !previous.some(
                    old => old.date === entry.date && old.type === entry.type
                  )
              )
            ];
          }
        }

        this.setState({ loading: true });

        this.props
          .addTailoring(values)
          .then(() => {
            this.props.findAllTailoring(this.state.siteSelected, this.state.selectedYear, this.state.selectedMonths).then(() => {
              Notify("success", "Successfully saved");
              this.tailoringForm.props.form.resetFields();
              this.setState({
                loading: false,
                addTailoringVisible: false,
                editTailoring: undefined,
                loggedDates: [], // Reset loggedDates after saving
              }, this.filterData);
            });
          })
          .catch((e) => {
            this.setState({ loading: false });
            Notify("error", e);
          });
      }
    });
  };
  handleSearchName = () => {
    if (!this.state.siteSelected) {
      return;
    }
    this.setState({ loading: true });
    this.props
      .findAllTailoring(this.state.siteSelected, this.state.selectedYear, this.state.selectedMonths)
      .then(() => {
        this.setState({ loading: false }, this.filterData);
      })
      .catch((e) => {
        this.setState({ loading: false });
        Notify('error', e.message || e);
      });
  };


  handleEditTailoring = e => {
    this.setState({ addTailoringVisible: true, editTailoring: e });
  };

  handleDeleteTailoring = e => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute("data");
    const { siteSelected, selectedYear, selectedMonths } = this.state;

    Modal.confirm({
      centered: true,
      title: 'Confirm delete',
      content: (
        <div>
          <h4>Are you sure you want to delete?</h4>
        </div>
      ),
      onCancel() {
        // no-op
      },
      onOk: async () => {
        this.setState({ loading: true });

        try {
          await this.props.deleteTailoring(id);

          // once deleted, re-fetch using the same filters
          await this.props.findAllTailoring(
            siteSelected,
            selectedYear,
            selectedMonths
          );

          Notify("success", "Successfully deleted");

          // hide spinner / modal / reset tab, then re-run filterData
          this.setState(
            {
              loading: false,
              deleteVisible: false,
              currentTab: "All"
            },
            this.filterData
          );
        } catch (err) {
          this.setState({ loading: false });
          Notify("error", err);
        }
      }
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ""
      ),
  });

  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };

  changeTypeTab = key => {
    this.setState({ currentTab: key });
  };

  // filterData = () => {
  //   const { selectedMonths, siteSelected } = this.state;
  //   const { tailoring } = this.props;

  //   const filteredData = tailoring
  //     .map((item) => {
  //       const loggedDates = item.loggedDates || [];

  //       // Check if any date matches a selected month
  //       const filteredLoggedDates = loggedDates.filter((log) => {
  //         const logMonth = dayjs(log.date).format("YYYY-MM");
  //         return selectedMonths.includes(logMonth);
  //       });

  //       // Match access/site
  //       const matchesSite = siteSelected
  //         ? item.access?.toString() === siteSelected.toString()
  //         : true;

  //       if (filteredLoggedDates.length === 0 || !matchesSite) {
  //         return null;
  //       }

  //       return {
  //         ...item,
  //         loggedDates: filteredLoggedDates,
  //       };
  //     })
  //     .filter((item) => item !== null);

  //   this.setState({ filteredData });
  // };

  filterData = () => {
    const { selectedYear, siteSelected } = this.state;
    const { tailoring } = this.props;

    const filteredData = tailoring
      .map((item) => {
        // Ensure loggedDates exists
        const loggedDates = item.loggedDates || [];

        // Filter by year
        const filteredLoggedDates = loggedDates.filter(log =>
          dayjs(log.date).format("YYYY") === String(selectedYear)
        );

        // Match site selection. access can be absent on older records, so
        // never call toString() on it directly.
        const matchesSite = siteSelected
          ? String(item.access || "") === String(siteSelected)
          : true;

        // The table is a per-year view, so hide users with nothing logged in
        // the selected year. They stay in props.tailoring, which is what the
        // duplicate check in handleAddTailoring searches — that lookup needs
        // every record for the site regardless of year.
        if (!matchesSite || filteredLoggedDates.length === 0) {
          return null;
        }

        return {
          ...item,
          loggedDates: filteredLoggedDates,
        };
      })
      .filter(item => item !== null);  // Remove null items
    this.setState({ filteredData });
  };

  exportCalendarToExcel = () => {
    const { filteredData, selectedYear, siteSelected } = this.state;
    if (!selectedYear) {
      message.warning("Please select a year first");
      return;
    }

    const yearInt = parseInt(selectedYear, 10);
    const wb = XLSX.utils.book_new();

    // Grab the site to read allowances
    const site = this.props.sites.find(s => s._id === siteSelected) || {};

    // Define each log type’s symbol, color, label, and allowance
    const letterMap = {
      Offdays: { sym: 'O', color: 'ADD8E6', label: 'Off', allowance: site.companyOffDays ?? 0 },
      Sickdays: { sym: 's', color: 'FFEB9C', label: 'Sick', allowance: site.companySickDays ?? 0 },
      'Leave Days': { sym: 'L', color: '90EE90', label: 'Leave', allowance: site.companyLeaveDays ?? 0 },
      Maternityleave: { sym: 'M', color: 'FFC0CB', label: 'Maternity', allowance: site.companyMaternityDays ?? 0 },
      Paternityleave: { sym: 'P', color: 'E0FFFF', label: 'Paternity', allowance: site.companyPaternityDays ?? 0 },
      Compassionateleave: { sym: 'C', color: 'FFEFD5', label: 'Compassionate', allowance: site.companyCompassionateDays ?? 0 },
    };
    const types = Object.keys(letterMap);

    filteredData.forEach(user => {
      const sheetName = user.user.substring(0, 31);

      // 1) Header row: Month | 1…31 | Off | Sick | Leave | Maternity | Paternity | Compassionate
      const header = [
        'Month',
        ...Array.from({ length: 31 }, (_, i) => String(i + 1)),
        ...types.map(type => letterMap[type].label)
      ];
      const aoa = [header];

      // 2) One row per month
      for (let m = 0; m < 12; m++) {
        const monthStart = dayjs().year(yearInt).month(m).date(1);
        const daysInMonth = monthStart.daysInMonth();
        const row = [monthStart.format('MMMM')];

        // a) day-by-day symbols
        for (let d = 1; d <= 31; d++) {
          if (d <= daysInMonth) {
            const cd = monthStart.date(d);
            const dateStr = cd.format('YYYY-MM-DD');
            const isSun = cd.day() === 0;
            const log = (user.loggedDates || []).find(l =>
              dayjs(l.date).format('YYYY-MM-DD') === dateStr
            );
            if (isSun) row.push('S');
            else if (log) row.push(letterMap[log.type].sym);
            else row.push('');
          } else {
            row.push('');
          }
        }

        // b) counts per type
        types.forEach(type => {
          const cnt = (user.loggedDates || []).filter(l => {
            const d = dayjs(l.date);
            return l.type === type
              && d.year() === yearInt
              && d.month() === m;
          }).length;
          row.push(cnt);
        });

        aoa.push(row);
      }

      // 3) Totals row at bottom: sum each type for full year
      const totals = types.map(type =>
        (user.loggedDates || []).filter(l =>
          dayjs(l.date).year() === yearInt && l.type === type
        ).length
      );
      const totalsRow = [
        'Total',
        ...Array(31).fill(''),
        ...totals
      ];
      aoa.push(totalsRow);

      // 4) Balance row: allowance minus total
      const balances = types.map((type, i) => {
        const allowance = letterMap[type].allowance;
        const used = totals[i];
        return allowance - used;
      });
      const balanceRow = [
        'Balance',
        ...Array(31).fill(''),
        ...balances
      ];
      aoa.push(balanceRow);

      // 5) Convert to sheet + styling
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const range = XLSX.utils.decode_range(ws['!ref']);

      // a) column widths
      ws['!cols'] = [
        { wch: 12 },                 // Month
        ...Array(31).fill({ wch: 3 }),
        ...types.map(() => ({ wch: 10 })) // Off, Sick, etc.
      ];

      // b) header styling (black bg, white text)
      for (let c = range.s.c; c <= range.e.c; c++) {
        const addr = XLSX.utils.encode_cell({ r: 0, c });
        if (ws[addr]) {
          ws[addr].s = {
            fill: { fgColor: { rgb: '000000' } },
            font: { color: { rgb: 'FFFFFF' }, bold: true },
            alignment: { horizontal: 'center' }
          };
        }
      }

      // c) color day-cells + Sundays
      const fillMap = {
        S: 'FF0000',  // Sundays red
        ...types.reduce((acc, t) => {
          acc[letterMap[t].sym] = letterMap[t].color;
          return acc;
        }, {})
      };
      for (let r = 1; r <= range.e.r; r++) {
        for (let c = 1; c <= 31; c++) {
          const addr = XLSX.utils.encode_cell({ r, c });
          const cell = ws[addr];
          if (!cell || !cell.v) continue;
          const hex = fillMap[cell.v];
          if (hex) {
            cell.s = {
              fill: { fgColor: { rgb: hex } },
              alignment: { horizontal: 'center' }
            };
          }
        }
      }

      // d) light-grey background on Totals row
      const totalRowIndex = aoa.length - 2; // second-last
      for (let c = range.s.c; c <= range.e.c; c++) {
        const addr = XLSX.utils.encode_cell({ r: totalRowIndex, c });
        if (ws[addr]) {
          ws[addr].s = {
            fill: { fgColor: { rgb: 'D3D3D3' } },
            font: { bold: true },
            alignment: { horizontal: 'center' }
          };
        }
      }

      // e) light-green background on Balance row
      const balanceRowIndex = aoa.length - 1;
      for (let c = range.s.c; c <= range.e.c; c++) {
        const addr = XLSX.utils.encode_cell({ r: balanceRowIndex, c });
        if (ws[addr]) {
          ws[addr].s = {
            fill: { fgColor: { rgb: 'E6FFEA' } },
            font: { bold: true },
            alignment: { horizontal: 'center' }
          };
        }
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    // 6) Write file
    XLSX.writeFile(wb, `Calendar-${yearInt}.xlsx`, {
      bookType: 'xlsx',
      cellStyles: true
    });
  };


  render() {
    let descriptions = this.props.tailoring.map(tailoring => {
      return { value: tailoring.description };
    });
    const { size } = this.state;
    const { tailoring } = this.props;
    let currentTailoring;
    if (this.state.currentTab === "All") {
      currentTailoring = tailoring;
    } else {
      currentTailoring = tailoring.filter(tailoring => tailoring.size === this.state.currentTab);
    }
    return (
      <div style={{ maxWidth: "90em", margin: "auto" }}>
        <LeaveRangePickerMobileStyles />
        <Spin spinning={this.state.loading}>
          {this.state.addTailoringVisible ? (
            <Cards
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: this.props.isMobile ? 0 : '75em',
                    fontSize: this.props.isMobile ? '17px' : '20px',
                    fontWeight: 800,
                    whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                    fontFamily: "Nunito",
                  }}
                >
                  {this.state.editTailoring ? 'Edit Leave Schedule' : 'Add Leave Schedule'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: this.props.isMobile ? '13px' : '16px',
                      whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editTailoring
                      ? "Fill in all fields and hit 'Save'"
                      : "Fill in all the fields and hit 'Save'"}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '0em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <TailoringForm
                  isMobile={this.props.isMobile}
                  selectedMonth={this.state.selectedYear}
                  sites={this.props.sites}
                  siteSelected={this.state.siteSelected}
                  stock={this.props.stock}
                  users={this.props.users}
                  descriptions={descriptions}
                  editTailoring={this.state.editTailoring}
                  wrappedComponentRef={form => (this.tailoringForm = form)}
                />{" "}
                {this.props.isMobile ? (
                  <MobileEditActions>
                    <Button
                      size="large"
                      icon={<StopFilled />}
                      onClick={() =>
                        this.setState({
                          addTailoringVisible: false,
                          editTailoring: undefined
                        })
                      }
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      icon={<CheckOutlined />}
                      onClick={this.handleAddTailoring}
                    >
                      {this.state.editTailoring ? 'Save Changes' : 'Save Schedule'}
                    </Button>
                  </MobileEditActions>
                ) : (
                  <FloatButton.Group
                    trigger="hover"
                    type="primary"
                    style={{ right: 24 }}
                    icon={<RocketFilled />}
                  >
                    <Tooltip placement="left" title="Save Item">
                      <FloatButton onClick={this.handleAddTailoring} icon={<PlusCircleFilled style={{ color: "#80CE90" }} />} />
                    </Tooltip>
                    <Tooltip placement="left" title="Cancel" >
                      <FloatButton onClick={e => this.setState({ addTailoringVisible: false })} icon={<StopFilled style={{ color: "red" }} />} />
                    </Tooltip>
                  </FloatButton.Group>
                )}
              </div>
            </Cards>
          ) : (
            <Row gutter={[16, 12]} style={{ marginTop: "1em" }}>
              <Col xs={24} lg={6}>
                <h1 style={{
                  marginBottom: '0em',
                  marginRight: "1em",
                  fontSize: '22px',
                  fontWeight: 800,
                  fontFamily: "Nunito",
                  marginTop: "0.3em",
                }}>Leave Schedule</h1>
              </Col>
              <Col xs={24} lg={18}>
                <LeaveToolbar>
                <Button
                  className="leave-export"
                  type="primary"
                  style={{ backgroundColor: "black", marginTop: "0.3em" }}
                  onClick={this.exportCalendarToExcel}
                >
                  <DownloadOutlined />
                </Button>
                <Button
                  className="leave-add"
                  type="primary"
                  onClick={this.onAddTailoring}
                  icon={
                    <PlusCircleFilled style={{ fontSize: '110%' }} />
                  }
                  size="large"
                  style={{}}
                >
                  Add Schedule
                </Button>
                {/* <Select
                  mode="multiple"
                  placeholder="Select Months"
                  size="large"
                  value={this.state.selectedMonths}
                  onChange={(selectedMonths) => {
                    // ✅ Prevent clearing the last selected item
                    if (selectedMonths.length === 0) {
                      message.warning("At least one month must remain selected.");
                      return;
                    }

                    this.setState({ selectedMonths }, () => {
                      this.filterData();
                    });
                  }}
                  style={{ width: 300, float: "right", marginRight: "1em" }}
                >
                  {Array.from({ length: 12 }, (_, i) => {
                    const monthValue = this.state.selectedYear
                      ? `${this.state.selectedYear}-${String(i + 1).padStart(2, "0")}`
                      : "";

                    return (
                      <Select.Option key={monthValue} value={monthValue}>
                        {dayjs().month(i).format("MMMM")}
                      </Select.Option>
                    );
                  })}
                </Select> */}

                <DatePicker
                  className="leave-year"
                  picker="year"
                  placeholder="Select Year"
                  format="YYYY"
                  value={this.state.selectedYear ? dayjs(`${this.state.selectedYear}-01-01`) : null}
                  onChange={(date) => {
                    const selectedYear = date ? dayjs(date).format("YYYY") : null;
                    this.setState({
                      selectedYear,
                      // selectedMonths: [] 
                    }, () => {
                      this.fetchAllTailoring().then(() => this.filterData());
                    });
                  }}
                  allowClear={false}
                  size="large"
                  style={{ width: this.props.isMobile ? '100%' : 200 }}
                />

                <Select
                  className="leave-site"
                  size="large"
                  value={this.state.siteSelected} // Bind selected value to state
                  showSearch
                  onChange={(value) => {
                    this.props.setSelectedSite(value);
                    this.setState({ siteSelected: value }, () => {
                      this.fetchAllTailoring().then(() => this.filterData());
                    });
                  }}
                  style={{ width: this.props.isMobile ? '100%' : '12em' }}
                  placeholder="Select Company"
                  optionFilterProp="children"
                >
                  {/* <Select.Option key="Admin" value="Admin">
                                    Admin
                                  </Select.Option> */}
                  {this.props.sites.map((site) => (
                    <Select.Option key={site._id} value={site._id}>
                      {site.name}
                    </Select.Option>
                  ))}
                </Select>
                </LeaveToolbar>
              </Col>
              <Col span={24}>
                <LeaveViewTabs defaultActiveKey="1">
                  {/* Tab 1: Table View */}
                  <TabPane tab="Table View" key="1">
                    <MobileTableHelp>
                      <strong>SWIPE</strong>
                      Swipe sideways for leave balances and actions.
                    </MobileTableHelp>
                    <StyledTable
                      bordered={false}
                      scroll={
                        this.props.isMobile
                          ? { x: 'max-content' }
                          : undefined
                      }
                      dataSource={
                        this.state.filteredData
                      }
                      rowKey="_id"
                      size="middle"
                      pagination={
                        false
                        //defaultPageSize: 25,
                      }
                      style={{
                        minWidth: "15em",
                        marginTop: "0.5em",
                      }}
                    >
                      {/* <Column title="Lodge / Banda" dataIndex="leaveLodge" key="leaveLodge" /> */}
                      <Column title="User" dataIndex="user" key="user" />
                      {/* Logged Dates Column */}
                      <Column
                        title="Upcoming"
                        dataIndex="loggedDates"
                        key="loggedDates"
                        width={250}
                        render={(dates = []) => {
                          const today = dayjs();

                          const leaveTypes = [
                            { type: 'Leave Days', label: 'Leave', color: 'green' },
                            { type: 'Offdays', label: 'Off Day', color: 'blue' },
                            { type: 'Sickdays', label: 'Sick Day', color: 'yellow' },
                            { type: 'Maternityleave', label: 'Maternity Leave', color: 'magenta' },
                            { type: 'Paternityleave', label: 'Paternity Leave', color: 'cyan' },
                            { type: 'Compassionateleave', label: 'Compassionate Leave', color: 'volcano' },
                          ];

                          // Build an array of the next-date items (only those that exist)
                          const upcoming = leaveTypes
                            .map(({ type, label, color }) => {
                              const nextLog = dates
                                .filter(log => log.type === type && dayjs(log.date).isSameOrAfter(today))
                                .sort((a, b) =>
                                  dayjs(a.date).diff(today) - dayjs(b.date).diff(today)
                                )[0];

                              return nextLog
                                ? { label, color, date: nextLog.date }
                                : null;
                            })
                            .filter(item => item !== null);

                          // If we have any upcoming items, render them; otherwise show one “none” message
                          return upcoming.length > 0 ? (
                            upcoming.map(({ label, color, date }) => (
                              <Tag color={color} key={label}>
                                {`Next ${label}: ${dayjs(date).format('YYYY-MM-DD')}`}
                              </Tag>
                            ))
                          ) : (
                            <span>No upcoming days</span>
                          );
                        }}
                      />

                      {/* Off Days */}
                      <Column

                        title="Off"
                        key="daysOffSelectedMonth"
                        render={(record) => {
                          const { selectedYear } = this.state;
                          if (!selectedYear) return "-";

                          // count how many maternity days in this month
                          const count = (record.loggedDates || []).filter(
                            log =>
                              log.type === "Offdays" &&
                              dayjs(log.date).format("YYYY") === selectedYear
                          ).length;

                          // pull in the site’s total leave allowance
                          const site = this.props.sites.find(
                            s => s._id === this.state.siteSelected
                          );
                          const totalLeave = site?.companyOffDays ?? 28;

                          return `${count} of ${totalLeave}`;
                        }}
                      />

                      {/* Sick Days */}
                      <Column

                        title="Sick"
                        key="daysSickSelectedMonth"
                        render={(record) => {
                          const { selectedYear } = this.state;
                          if (!selectedYear) return "-";

                          // count how many maternity days in this month
                          const count = (record.loggedDates || []).filter(
                            log =>
                              log.type === "Sickdays" &&
                              dayjs(log.date).format("YYYY") === selectedYear
                          ).length;

                          // pull in the site’s total leave allowance
                          const site = this.props.sites.find(
                            s => s._id === this.state.siteSelected
                          );
                          const totalLeave = site?.companySickDays ?? 28;

                          return `${count} of ${totalLeave}`;
                        }}
                      />

                      {/* Annual Leave */}
                      <Column

                        title="Leave"
                        key="leaveDaysSelectedMonth"
                        render={(record) => {
                          const { selectedYear } = this.state;
                          if (!selectedYear) return "-";

                          // count how many maternity days in this month
                          const count = (record.loggedDates || []).filter(
                            log =>
                              log.type === "Leave Days" &&
                              dayjs(log.date).format("YYYY") === selectedYear
                          ).length;

                          // pull in the site’s total leave allowance
                          const site = this.props.sites.find(
                            s => s._id === this.state.siteSelected
                          );
                          const totalLeave = site?.companyLeaveDays ?? 28;

                          return `${count} of ${totalLeave}`;
                        }}
                      />

                      {/* Maternity Leave */}
                      <Column

                        title="Maternity"
                        key="maternityLeaveSelectedMonth"
                        render={(record) => {
                          const { selectedYear } = this.state;
                          if (!selectedYear) return "-";

                          // count how many maternity days in this month
                          const count = (record.loggedDates || []).filter(
                            log =>
                              log.type === "Maternityleave" &&
                              dayjs(log.date).format("YYYY") === selectedYear
                          ).length;

                          // pull in the site’s total leave allowance
                          const site = this.props.sites.find(
                            s => s._id === this.state.siteSelected
                          );
                          const totalLeave = site?.companyMaternityDays ?? 28;

                          return `${count} of ${totalLeave}`;
                        }}
                      />
                      {/* Paternity Leave */}
                      <Column

                        title="Paternity"
                        key="paternityLeaveSelectedMonth"
                        render={(record) => {
                          const { selectedYear } = this.state;
                          if (!selectedYear) return "-";

                          // count how many maternity days in this month
                          const count = (record.loggedDates || []).filter(
                            log =>
                              log.type === "Paternityleave" &&
                              dayjs(log.date).format("YYYY") === selectedYear
                          ).length;

                          // pull in the site’s total leave allowance
                          const site = this.props.sites.find(
                            s => s._id === this.state.siteSelected
                          );
                          const totalLeave = site?.companyPaternityDays ?? 28;

                          return `${count} of ${totalLeave}`;
                        }}
                      />

                      {/* Compassionate Leave */}
                      <Column

                        title="Compassionate"
                        key="compassionateLeaveSelectedMonth"
                        render={(record) => {
                          const { selectedYear } = this.state;
                          if (!selectedYear) return "-";

                          // count how many maternity days in this month
                          const count = (record.loggedDates || []).filter(
                            log =>
                              log.type === "Compassionateleave" &&
                              dayjs(log.date).format("YYYY") === selectedYear
                          ).length;

                          // pull in the site’s total leave allowance
                          const site = this.props.sites.find(
                            s => s._id === this.state.siteSelected
                          );
                          const totalLeave = site?.companyCompassionateDays ?? 28;

                          return `${count} of ${totalLeave}`;
                        }}
                      />
                      {/* Off Days Column */}
                      {/* <Column
                        title="Off Days Used"
                        key="offDaysUsed"
                        render={(record) => {
                          const { selectedMonth } = this.state;

                          if (!selectedMonth) return "-";

                          // Extract year from selectedMonth
                          const selectedYear = dayjs(selectedMonth, "YYYY").year();

                          const offDays = record.loggedDates.filter(
                            (log) =>
                              log.type === "Offdays" &&
                              dayjs(log.date).year() === selectedYear // Match the year
                          ).length;

                          return offDays;
                        }}
                      /> */}

                      {/* Leave Days Column */}
                      {/* <Column
                        title="Leave Days Used"
                        key="leaveDaysUsed"
                        render={(record) => {
                          const { selectedMonth } = this.state;

                          if (!selectedMonth) return "-";

                          const selectedYear = dayjs(selectedMonth, "YYYY").year();

                          const leaveDays = record.loggedDates.filter(
                            (log) =>
                              log.type === "Leave Days" &&
                              dayjs(log.date).year() === selectedYear // Match the year
                          ).length;

                          return leaveDays;
                        }}
                      /> */}

                      {/* <Column
                        title="Leave Balance"
                        key="leaveBalance"
                        render={(record) => {
                          const { selectedMonth } = this.state;

                          if (!selectedMonth) return "-";

                          const annualLeave = `${this.props.sites.find(site => site._id === this.state.siteSelected)?.companyLeaveDays || 28}`; // Total annual leave days
                          const selectedYear = dayjs(selectedMonth, "YYYY").year();

                          const leaveDaysUsed = record.loggedDates.filter(
                            (log) =>
                              log.type === "Leave Days" &&
                              dayjs(log.date).year() === selectedYear // Match the year
                          ).length;

                          return annualLeave - leaveDaysUsed;
                        }}
                      /> */}
                      <Column
                        title="Days Worked (to date)"
                        key="daysWorked"
                        render={(record) => {
                          const { selectedYear } = this.state;
                          if (!selectedYear) return "-";

                          // Determine the year, and the “cut-off” date (today or end of year)
                          const year = parseInt(selectedYear, 10);
                          const today = dayjs();
                          const endDate = today.year() === year
                            ? today
                            : dayjs(`${year}-12-31`);

                          // Total days from Jan 1 up to cut-off
                          const totalDaysUpTo = endDate.dayOfYear();

                          // All non-working leave types
                          const nonWorkingTypes = [
                            "Offdays",
                            "Sickdays",
                            "Leave Days",
                            "Maternityleave",
                            "Paternityleave",
                            "Compassionateleave"
                          ];

                          // Count how many of those dates occur in this year before cut-off
                          const nonWorkingCount = (record.loggedDates || []).filter(log =>
                            nonWorkingTypes.includes(log.type) &&
                            dayjs(log.date).year() === year &&
                            dayjs(log.date).isBefore(endDate, "day")
                          ).length;

                          const daysWorked = totalDaysUpTo - nonWorkingCount;
                          return daysWorked >= 0 ? daysWorked : 0;
                        }}
                      />




                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        fixed={this.props.isMobile ? 'right' : undefined}
                        width={96}
                        render={(text, tailoring) => (
                          <span>
                            <EditFilled
                              style={{
                                backgroundColor: '#80CE90',
                                color: 'white',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditTailoring(tailoring)}
                            />

                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: 'crimson',
                                color: "white",
                                padding: "0.5em",
                                borderRadius: "3em",
                              }}
                              data={tailoring._id}
                              onClick={this.handleDeleteTailoring}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane>

                  {/* Tab 2: Calendar View */}
                  <TabPane tab="Calendar View" key="2">
                    <MonthlyCalendarGrid
                      data={this.state.filteredData}
                      year={this.state.selectedYear}
                      isMobile={this.props.isMobile}
                    />
                    {/* <MonthlyCalendarGrid
                      data={this.state.filteredData}
                      year={this.state.selectedYear}
                      selectedMonths={this.state.selectedMonths}
                    /> */}
                  </TabPane>
                </LeaveViewTabs>
              </Col>
            </Row>
          )}
        </Spin>
      </div>
    );
  }
}

const WrappedTailoring = Form.create()(withIsMobile(Tailoring));
export default WrappedTailoring;
